import { render, staticRenderFns } from "./allComplaints.vue?vue&type=template&id=4d1a93e3&scoped=true&"
import script from "./allComplaints.vue?vue&type=script&lang=js&"
export * from "./allComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a93e3",
  null
  
)

export default component.exports